import React from 'react';

const FocusTimerAbout = () => {
  return (
    <div className="px-4 py-8 sm:px-6 lg:px-12 text-gray-200">
      <h2 className="text-yellow-400 text-3xl font-semibold mb-4">Think5Whys Focus Timer (TFT)</h2>
      <p className="text-lg mb-6">
        <strong className="text-yellow-200">Think5Whys Focus Timer (TFT)</strong> helps users manage their time effectively by breaking work or study sessions into intervals with short breaks. Based on the <strong className="text-yellow-200">Pomodoro Technique</strong>, it typically consists of 25-minute focused sessions followed by 5-minute breaks to maintain productivity.
      </p>

      <h3 className="text-yellow-400 text-2xl font-medium mt-8 mb-4">Why TFT?</h3>
      <ul className="list-disc pl-6 space-y-4">
        <li><strong>Productivity Tools</strong>: Helps manage time while working or studying.</li>
        <li><strong>Learning Management Systems (LMS)</strong>: Encourages students to focus during study sessions.</li>
        <li><strong>Task Management Systems</strong>: Allocates dedicated time for tasks or projects.</li>
        <li><strong>Workplace Collaboration Platforms</strong>: Facilitates time management in team projects.</li>
        <li><strong>Fitness and Wellness Apps</strong>: Guides focused workouts or mindfulness exercises.</li>
        <li><strong>Rewards</strong>: Users earn points or badges for completing focused sessions.</li>
        <li><strong>HR Tools</strong>: Helps distributed teams maintain productivity and avoid burnout.</li>
        <li><strong>Child Motivator Tool</strong>: Engages children with enhanced focus.</li>
        <li><strong>Remote Work Platforms</strong>: Helps teams synchronize work schedules with breaks.</li>
        <li><strong>Time Tracking Tools</strong>: Tracks time spent on tasks, offering insights into productivity.</li>
      </ul>

      <p className="text-yellow-200 mt-6">
        Think5Whys Focus Timer enhances user productivity, time management, and overall engagement across multiple domains.
      </p>

      <h3 className="text-yellow-400 text-2xl font-medium mt-12 mb-4">What is Pomodoro?</h3>
      <p className="text-lg mb-4">The Pomodoro Technique is a time management method developed by Francesco Cirillo in the 1980s. It works as follows:</p>
      
      <ol className="list-decimal pl-6 space-y-4">
        <li><strong>Set a Timer</strong>: Choose a task and set a 25-minute timer ("Pomodoro").</li>
        <li><strong>Work on the Task</strong>: Focus exclusively on the task until the timer rings.</li>
        <li><strong>Take a Short Break</strong>: Relax for 5 minutes after each Pomodoro session.</li>
        <li><strong>Repeat</strong>: Continue alternating between work sessions and breaks.</li>
        <li><strong>Long Breaks</strong>: After four Pomodoros, take a 15-30 minute break.</li>
      </ol>

      <p className="text-yellow-200 mt-6">
        The technique enhances productivity by creating focused work intervals, followed by breaks to prevent burnout. It helps users work in harmony with time, fostering motivation and reducing procrastination.
      </p>

      <p className="text-yellow-400 mt-8 text-lg">
        The name "Pomodoro" comes from the Italian word for "tomato." Cirillo named the technique after the tomato-shaped kitchen timer he used as a student.
      </p>
    </div>

  );
};

export default FocusTimerAbout;
